import React from 'react';
import { Clearfix } from 'react-bootstrap';
import { connect } from 'react-redux';
import { injectIntl, FormattedNumber } from 'react-intl';
import { isEmpty as _isEmpty, toString as _toString } from 'lodash';

import { getTextColor } from 'components/forms/autocomplete/Color';

class VklFilterDesktopValue extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mouseOver: false,
    };
  }

  getValueName() {
    const {
      intl: { messages },
      facetName,
      value,
    } = this.props;

    let mapping = {};
    if (facetName === 'status') {
      mapping = {
        100: messages.sad.offer_made,
        300: messages.sad.in_progress,
        500: messages.sad.predecessor_offer,
        700: messages.sad.lost,
        900: messages.sad.ordered,
        950: messages.sad.canceled,
      };
    } else if (facetName === 'isInternalActivity') {
      mapping = {
        true: messages.yes,
        false: messages.no,
      };
    }

    if (mapping.hasOwnProperty(value._id)) {
      return mapping[value._id];
    }
    const label = _isEmpty(_toString(value.name)) ? value._id : value.name;
    return _isEmpty(_toString(label)) ? 'unbekannt' : label;
  }

  render() {
    const { type, value, yesMessage, checked, onClick } = this.props;
    const { mouseOver } = this.state;

    return (
      <div
        class={'p-t-10 p-b-10 p-r-10 p-l-10 cursor ' + (mouseOver ? ' bg-master-lightest' : '')}
        onMouseEnter={() => this.setState({ mouseOver: true })}
        onMouseLeave={() => this.setState({ mouseOver: false })}
        onClick={() => onClick(value._id, !checked)}
      >
        <Clearfix class="v-align-middle">
          {type === 'select' ? (
            <span
              class={'m-r-10 b-a v-align-middle block pull-left text-center ' + (mouseOver ? '' : 'b-grey ')}
              style={{ height: '24px', width: '24px' }}
            >
              {checked ? <i class="fa fa-check" /> : null}
            </span>
          ) : null}

          {type === 'colors' && (
            <span
              class="m-r-10 v-align-middle block pull-left b-a b-grey text-center"
              style={{ height: '24px', width: '24px', borderRadius: '50%', background: value.color }}
            >
              {checked ? <i class="fa fa-check" style={{ color: getTextColor(value.color) }} /> : null}
            </span>
          )}

          <a
            href="#select"
            class={'text-black ' + (value.count === 0 ? 'hint-text ' : ' ') + (checked ? 'bold' : ' ')}
            onClick={e => e.preventDefault()}
          >
            {type === 'boolean' ? yesMessage : this.getValueName()}
          </a>

          {value.count > 0 ? (
            <div class="m-l-15 hint-text pull-right">
              {value.countOrders} / {value.count} (
              <FormattedNumber value={value.countOrders / value.count} style="percent" />)
            </div>
          ) : (
            <div class="m-l-15 hint-text pull-right">-</div>
          )}
        </Clearfix>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default injectIntl(connect(mapStateToProps)(VklFilterDesktopValue));
